// extracted by mini-css-extract-plugin
module.exports =  {"content":"_772e1b1e50--content--AL97H","with-shadow":"_772e1b1e50--with-shadow--SQnCQ"};